import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import Header from "../PackageInfo/Header";
import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";
import and1 from "../../Images/Andharban/and1.PNG";
import and2 from "../../Images/Andharban/and2.PNG";
import and3 from "../../Images/Andharban/and3.JPG";
import and4 from "../../Images/Andharban/and6.jpg";
import and5 from "../../Images/Andharban/and5.jpg";

const data = [
  {
    day: "Day 1",
    subheading: "Andharban Jungle Trek",
    schedule: [
      { time: "05:00 AM", activity: "Pick-up at Hadapsar." },
      { time: "05:20 AM", activity: "Pick-up at Swargate." },
      { time: "05:40 AM", activity: "Pick-up at Vanaj Metro Station." },
      { time: "05:55 AM", activity: "Pick-up at Wakad Bridge." },
      { time: "06:10 AM", activity: "Pick-up at Hinjwadi." },
      {
        time: "08:30 AM",
        activity: "Arrive at base village and trek briefing.",
      },
      {
        time: "8:45 AM",
        activity: "Breakfast at base village.",
      },
      {
        time: "09:30 AM",
        activity: "Begin the trek through Andharban Jungle.",
      },
      {
        time: "12:00 AM",
        activity: "Explore the jungle and enjoy the refreshing waterfall.",
      },
      {
        time: "02:00 PM",
        activity: "Begin return trek towards the base village.",
      },
      {
        time: "04:00 PM",
        activity: "Reach base village and enjoy Delicious Veg & Non-Veg Lunch.",
      },
      {
        time: "05:00 PM",
        activity: "Start the return journey to Pune.",
      },
      {
        time: "10:00 PM",
        activity: "Approx. arrival back in Pune.",
      },
    ],
    meals: ["Breakfast", "Lunch", "Tea"],
    notes: [
      "Entry for Andharban is now limited to a fixed number of participants per day. To secure a confirmed slot, please book at the earliest and avoid any last-minute hassle.",
    ],
    inclusions: [
      "🚌 Pune to Pune Travel by Non-AC Bus",
      "🍽️ Breakfast",
      "🥘 Delicious Veg & Non-Veg Lunch",
      "☕ Evening Tea",
      "🩺 Basic First Aid & Hydration Powder",
      "🧭 Experienced Trek Lead & Guide",
      "🌲 Forest Entry & Charges",
    ],
    exclusions: [
      'Any other charges not mentioned in "Inclusions"',
      "Personal snacks, cold drinks, and extra food expenses.",
      "Any personal insurance or medical expenses beyond basic first aid.",
      "Items of personal nature or additional equipment not listed.",
      "Photography or videography permits (if applicable).",
    ],
    verticalCards: [
      { title: "Dense Jungle", image: and1 },
      { title: "Forest Stream", image: and2 },
      { title: "Jungle Waterfall", image: and3 },
      { title: "Flora & Fauna", image: and4 },
      { title: "Natural Path", image: and5 },
    ],
    trekData: [
      {
        name: "Andharban Jungle Trail",
        image: and2,
        info: "Experience the breathtaking 13 km Andharban Trek, one of the most scenic monsoon treks in Tamhini Ghat, Maharashtra. Famous for its dense evergreen rainforest, mist-covered trails, and vibrant biodiversity, Andharban—meaning Dark Forest — offers a unique downhill trekking experience through the lush landscapes of the Sahyadri Mountains. Along the trail, trekkers are rewarded with stunning panoramic views of the Kundalika Valley and the winding Kundalika River, especially during the monsoon when countless waterfalls come alive. The route also features stream crossings, cool forest canopies, and excellent opportunities for nature photography and birdwatching. Ideal for adventure seekers and nature lovers, the Andharban Trek combines scenic beauty, rich flora and fauna, and an unforgettable wilderness experience, making it one of the best trekking destinations near Pune and Mumbai during the rainy season.",
      },
    ],
    faq: [
      {
        question: "What is Andharban Jungle Trek known for?",
        answer:
          "Andharban is famous for its dense, lush jungle canopy, scenic waterfall, and high biodiversity. The trek offers an immersive jungle experience with streams, diverse flora and fauna, and pristine natural beauty.",
      },
      {
        question: "Is this trek suitable for beginners?",
        answer:
          "Yes. The trail is moderately easy and perfect for beginners with decent fitness levels. The muddy and slippery terrain requires careful footing, especially during monsoon.",
      },
      {
        question: "What should I carry for the trek?",
        answer:
          "Carry a small backpack, water bottle, rain gear, comfortable trekking shoes, sunscreen, and any personal medicine.",
      },
      {
        question: "Are meals included?",
        answer:
          "Yes. Breakfast, morning tea, lunch, and evening tea are included in the package.",
      },
      {
        question: "Is transportation included?",
        answer:
          "Yes, Pune to Pune travel by NON-AC bus is included in the package.",
      },
      {
        question: "Will we visit the waterfall?",
        answer:
          "Yes, we will visit the scenic waterfall and natural pools in the jungle. The waterfall is accessible and offers a refreshing experience.",
      },
      {
        question: "What wildlife can we expect?",
        answer:
          "Andharban is known for its biodiversity including various bird species, butterflies, insects, and small mammals. You may spot monkeys, squirrels, and various bird species during the trek.",
      },
      {
        question: "Will there be a trek leader and guide?",
        answer:
          "Yes, an experienced trek lead and local guide will accompany the group throughout the trek and provide insights about the jungle ecosystem.",
      },
      {
        question: "Is the trail safe during monsoon?",
        answer:
          "Yes, the trail is safe during monsoon with proper guidance. However, the terrain can be slippery, so wearing proper trekking shoes and being cautious is essential.",
      },
    ],
  },
];

const Andharban = () => {
  return (
    <div className="bg-gray-50 ">
      <Header trekData={data[0].trekData[0]} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TrekBasicInfo
          trekName="Andharban Jungle Trek"
          location="Tamhini Ghat"
          trekDifficulty="Moderate"
          ageLimit="16 to 36 Years"
        />
        <PackageInclusions />
      </div>
      <ItineraryTimeline itinerary={data} />
      <ImageCardsWithVerticalView verticalCards={data[0].verticalCards} />
      <ModalTriggerList
        inclusions={data[0].inclusions}
        exclusions={data[0].exclusions}
        type="trek"
        faq={data[0].faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default Andharban;
